<template>
  <div>
    <h2 class="pb-4">
      <v-btn icon @click="back()" class="mx-0 pb-2">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      {{Destination}}{{Including}}
    </h2>
    <v-alert outlined dense>
      <template v-slot:prepend>
        <v-avatar
          size="52"
          min-height="52"
          tile
          v-if="Status"
          >
          <v-img
            max-height="32"
            max-width="32"
            contain
            :src="icon"
            ></v-img>
        </v-avatar>
      </template>
      <strong>
        <span v-if="StatusTranslated">{{StatusTranslated}}</span>
        <span v-else>{{Status}}</span>
        <span v-if="StatusSubtitle"> - {{StatusSubtitle}}</span>
      </strong>
    </v-alert>
    <p>{{Description1}}</p>
    <div v-if="Links && Links.length > 0">
      {{LinksHeading}}
      <ul class="mt-2">
        <li v-for="(link, i) in Links" :key="i" class="mb-2">
          <a
            target="_blank"
            :href="link.href"
            v-on:click.stop="getOutboundLink('Bushfire Map Destination Info', link.href, true)"
            >{{link.title || link.href}}</a>
        </li>
      </ul>
    </div>
    <figure v-if="ImageURL" class="mb-3">
      <v-img v-if="ImageURL" :src="ImageURL" max-width="300">
        <template v-slot:placeholder>
          <v-row
            class="fill-height ma-0"
            align="center"
            justify="center"
            >
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </figure>
    <p>{{Description2}}</p>
  </div>
</template>
<script>
  export default {
    props: {
      'Destination': String,
      'Including': String,
      'Status': String,
      'StatusTranslated': String,
      'StatusSubtitle': String,
      'LinksHeading': String,
      'Description1': String,
      'ImageURL': String,
      'Description2': String,
      'Links': Array,
      'icon': String
    },
    methods: {
      back: function () {
        this.$emit('clearFeature')
      },
      /**
       * Function that registers a click on an outbound link in Analytics.
       * This function takes a valid URL string as an argument, and uses that URL string
       * as the event label. Setting the transport method to 'beacon' lets the hit be sent
       * using 'navigator.sendBeacon' in browser that support it.
       */
      getOutboundLink: function (category, url, external) {
        this.$gtag.event('Click', {
          'event_category': category,
          'event_label': url,
          'transport_type': 'beacon',
          'event_callback': function(){ if (!external) { document.location = url }}
        })
      }
    }
  }
</script>
<style scoped>
  figure {
    text-align: center;
  }
</style>
